import { FC, useEffect, useState } from 'react'
import {
    loginAnimEstimates, loginAnimInspections, loginAnimRenovations, loginAnimRepairs
} from '../../../../../assets'
import useStyles from './styles'
import { LoginAnimationProps } from './types'

// TODO: improve fade in/out animation

const LoginAnimation: FC<LoginAnimationProps> = ({ timeout = 6000 }) => {
  const classes = useStyles()

  const [animation, setAnimation] = useState(0)

  const getAnimation = () => {
    switch (animation) {
      case 0: return loginAnimRepairs
      case 1: return loginAnimEstimates
      case 2: return loginAnimRenovations
      case 3: return loginAnimInspections
    }
  }

  useEffect(() => {
    let isMounted = true
    setTimeout(() => {
      if (isMounted) { setAnimation((animation + 1) % 4) }
    }, timeout)
    return () => { isMounted = false }
  }, [animation, timeout])

  return (
    <img src={getAnimation()} alt='' className={classes.image} />
  )
}

export default LoginAnimation
